export const ADDON_ID = 'marker';
export const TOOL_ID = `${ADDON_ID}/tool`;

export const EVENTS = {
  LOADED: `${ADDON_ID}/loaded`,
  CAPTURE: `${ADDON_ID}/capture`,
};
